"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _FieldHelperText = _interopRequireDefault(require("../FieldHelperText"));
var _StyledCheckbox = _interopRequireDefault(require("../StyledCheckbox"));
var _excluded = ["label", "labelClassName", "helperText"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    label: {
      color: theme.palette.darkGrey.light
    },
    helperText: {
      marginTop: theme.spacing(0),
      marginLeft: theme.spacing(3.6),
      color: theme.palette.darkGrey.light
    }
  };
});
var SingleCheckbox = function SingleCheckbox(_ref) {
  var label = _ref.label,
    labelClassName = _ref.labelClassName,
    helperText = _ref.helperText,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    className: cx(classes.label, helperText, labelClassName),
    control: /*#__PURE__*/_react["default"].createElement(_StyledCheckbox["default"], other),
    label: label
  }), helperText && /*#__PURE__*/_react["default"].createElement(_FieldHelperText["default"], {
    className: classes.helperText
  }, helperText));
};
SingleCheckbox.propTypes = {
  label: _propTypes["default"].string,
  labelClassName: _propTypes["default"].string,
  helperText: _propTypes["default"].string
};
SingleCheckbox.defaultProps = {
  label: undefined,
  labelClassName: undefined,
  helperText: undefined
};
var _default = SingleCheckbox;
exports["default"] = _default;